import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import { useAppDispatch } from "../../../redux/hooks";
import {
    onAddWorkorderBatch,
    onSetBatchesAdding,
    onSetBatchesAddingMultiple,
    onSetBatchesAddingMultipleDays,
    onSetSelectedBatches,
    onUpdateWorkorderBatch,
    workorderManagementAddMultipleBatches,
    workorderManagementDeleteBatch,
    workorderManagementSaveBatch
} from "../../../redux/slices/workorderManagement.feature";
import { DtGridPropsOptions2 } from "../../../types/dtGridPropsOptions2";
import { IRootState } from "../../../types/redux/IRootStore";
import { DtGrid2 } from "../../common/DtGrid2";
import { getWorkorderManagementBatchPaneColumns } from "./WorkorderManagementBatchPaneColumns";
import "./WorkorderManagementBatchPane.css";
import { useTranslation } from "react-i18next";
import { getExceptionText, translateColumns, translateString } from "../../../translations/gridTranslationHelper";
import { WorkorderManagementBatch } from "../../../types/workorderManagementBatch";

export default function WorkorderManagementBatchPane() {
    const { t } = useTranslation();
    const workorderManagementRedux = useSelector((state: IRootState) => state.workorderManagement);
    const dispatch = useAppDispatch();
    const aplSettings = AplSettingsSelector();

    const [page, setPage] = React.useState(1);

    const setSelected = (x: any) => {
        dispatch(onSetSelectedBatches(x));
        dispatch(onSetBatchesAdding([]));
        dispatch(onSetBatchesAddingMultiple(false));
    };

    const updateBatchRedux = (workorderBatch: WorkorderManagementBatch) => {
        dispatch(onUpdateWorkorderBatch(workorderBatch));
    };
    const saveBatchFetchCurrentState = (workorderBatch: WorkorderManagementBatch) =>
        dispatch(workorderManagementSaveBatch(workorderBatch) as any);

        const deleteBatchFetchCurrentState = (workorderBatch: WorkorderManagementBatch) =>
        dispatch(workorderManagementDeleteBatch(workorderBatch) as any);

    const dtGridOptns: DtGridPropsOptions2 = {
        data: workorderManagementRedux.orderBatchesData,
        columnData: translateColumns(
            getWorkorderManagementBatchPaneColumns(
                aplSettings.culture,
                updateBatchRedux,
                workorderManagementRedux.orderBatchesSelected,
                saveBatchFetchCurrentState,
                deleteBatchFetchCurrentState
            ),
            aplSettings.culture
        ),
        defaultSort: {
            field: ["shiftStart"],
            direction: ["desc"]
        },
        selectType: "single",
        colouring: false,
        headerFilters: false,
        setSelectedItems: setSelected,
        selectedItems: workorderManagementRedux.orderBatchesSelected,
        tableName: "tblWorkorderBatches",
        tableClass: "table-workorder-batches",
        paging: true,
        pageLength: 12,
        page: page,
        setPage: setPage,
        showSpinner: false,
        rowId: "workOrderBatchId",
        loading: workorderManagementRedux.orderBatchesDataLoading,
        bulk: false,
        filters: {},
        setFilters: _.noop,
        refreshSelectedOnDataChange: true
    };

    return (
        <React.Fragment>
            <div className="container mw-100 p-2 pt-0 mt-1">
                {workorderManagementRedux.orderBatchesDataError ? (
                    <div id="div-error" className={`alert alert-danger ${workorderManagementRedux.orderBatchesDataError ? "" : "hide"}`} role="alert">
                        {getExceptionText(workorderManagementRedux.orderBatchesDataError, aplSettings.culture)}
                    </div>
                ) : null}

                <div className="row ml-1 mr-1">
                    <div className="col-sm-12">
                        <DtGrid2 options={dtGridOptns} />
                    </div>
                </div>
                <div className="row ml-1">
                    <div className="col-sm-7">&nbsp;</div>
                    <div className="col-sm-1 mt-1"></div>
                    <div className="col-sm-4">
                        <div className="input-group">
                            <input
                                type="number"
                                placeholder={translateString("noDays", aplSettings.culture)}
                                className="form-control"
                                onChange={e => {
                                    dispatch(onSetBatchesAddingMultipleDays(e.currentTarget.valueAsNumber));
                                }}
                                value={workorderManagementRedux.orderBatchesData.length === 0 ? 1 : workorderManagementRedux.orderBatchesAddingMultipleDays}
                                disabled={workorderManagementRedux.orderBatchesData.length === 0}
                            ></input>
                            <div className="input-group-append">
                                {workorderManagementRedux.orderBatchesData.length > 0 ? (
                                    <button
                                        id="btn-add-multiple-batches"
                                        className="btn btn-primary"
                                        onClick={() => {
                                            dispatch(
                                                workorderManagementAddMultipleBatches(
                                                    workorderManagementRedux.orderBatchesAddingMultipleDays
                                                ) as any
                                            );
                                        }}
                                    >
                                        {t("main.addMultipleBatches")}
                                    </button>
                                ) : null}
                            </div>
                            &nbsp;
                            <div className="input-group-append">
                                <button
                                    id="btn-insert-single-batch"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        dispatch(onAddWorkorderBatch());
                                    }}
                                    disabled={workorderManagementRedux.orderBatchesSelected.length > 0}
                                >
                                    {t("main.insert")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
